// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LostAndFoundHistoryForm .h4,
.LostAndFoundHistoryForm label,
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHeader,
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHistoryTitle {
  color: var(--bs-primary);
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHeader {
  padding-bottom: 1rem;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHeader > .col {
  display: flex;
  flex-direction: column;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHeader > .col .LostAndFoundHistoryFormTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormSectionHeader {
  padding-bottom: 1rem;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormSectionHeader .LostAndFoundHistoryFormCommentsTitle {
  padding: 0.5rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormUpload {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHistory {
  padding-bottom: 1rem;
}
.LostAndFoundHistoryForm .LostAndFoundHistoryFormHistory .LostAndFoundHistoryFormHistoryTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.LostAndFoundHistoryForm .TextArea[name=description],
.LostAndFoundHistoryForm .TextArea[name=notes] {
  height: 7rem !important;
  resize: none !important;
}
.LostAndFoundHistoryForm .btn {
  text-transform: uppercase;
}
.LostAndFoundHistoryForm .btn[type=SUBMIT] {
  width: 100%;
  margin: 2rem 0;
}
.LostAndFoundHistoryForm .SimpleTable-Controls {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/features/LostAndFoundHistory/components/LostAndFoundHistoryForm/styles.scss"],"names":[],"mappings":"AACE;;;;EAIE,wBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;AACN;AAAM;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AAER;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,wBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;EACE,mBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;;EAEE,uBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,yBAAA;AAAJ;AACI;EACE,WAAA;EACA,cAAA;AACN;AAEE;EACE,wBAAA;AAAJ","sourcesContent":[".LostAndFoundHistoryForm {\n  .h4,\n  label,\n  .LostAndFoundHistoryFormHeader,\n  .LostAndFoundHistoryFormHistoryTitle {\n    color: var(--bs-primary);\n  }\n  .LostAndFoundHistoryFormHeader {\n    padding-bottom: 1rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      .LostAndFoundHistoryFormTitle {\n        padding: 0.25rem 0 1rem 0;\n        border-bottom: 1px solid #ccc;\n        text-transform: uppercase;\n      }\n    }\n  }\n  .LostAndFoundHistoryFormSectionHeader {\n    padding-bottom: 1rem;\n    .LostAndFoundHistoryFormCommentsTitle {\n      padding: 0.5rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .LostAndFoundHistoryFormUpload {\n    padding-top: 0.6rem;\n    padding-bottom: 0.6rem;\n  }\n  .LostAndFoundHistoryFormHistory {\n    padding-bottom: 1rem;\n    .LostAndFoundHistoryFormHistoryTitle {\n      padding: 0.25rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .TextArea[name='description'],\n  .TextArea[name='notes'] {\n    height: 7rem !important;\n    resize: none !important;\n  }\n  .btn {\n    text-transform: uppercase;\n    &[type='SUBMIT'] {\n      width: 100%;\n      margin: 2rem 0;\n    }\n  }\n  .SimpleTable-Controls {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
